<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chartDataset: {
        labels: ["2015", "2017", "2019", "2021", "2023"],
        datasets: [
          {
            data: this.chartData,
            backgroundColor: "rgba(10, 10, 10, 0.7)",
            borderWidth: 0,
          },
        ],
      },
      chartOptions: {
        layout: {
          padding: {
            top: 25,
          },
        },
        elements: {
          point: {
            radius: 7,
            hoverRadius: 8,
          },
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              display: false,
            },
          ],
        },
        tooltips: {
          enabled: false,
        },
        onClick: this.selectYear,
        onHover: function (e) {
          let point = this.getElementAtEvent(e);
          if (point.length) e.target.style.cursor = "pointer";
          else e.target.style.cursor = "default";
        },
        plugins: {
          datalabels: {
            display: (c) => {
              let index = c.dataIndex;
              let value = c.dataset.data[index];
              return value != 0;
            },
            align: "end",
            offset: 5,
          },
        },
      },
    };
  },
  methods: {
    selectYear(event, array) {
      let clickedId = array[0]["_index"] * 2 + 2015;
      let index = this.$store.state.filters.year.indexOf(clickedId);
      if (index > -1) this.$store.state.filters.year.splice(index, 1);
      else this.$store.state.filters.year.push(clickedId);
    },
  },
  mounted() {
    this.renderChart(this.chartDataset, this.chartOptions);
  },
  watch: {
    chartData() {
      this.chartDataset.datasets[0].data = this.chartData;
      this.$data._chart.update();
    },
  },
};
</script>